import { Link } from 'react-router-dom';

import { Permission } from '../../../../../../../backend/src/auth/permissions/permission';
import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { PermissionGate } from '@/hooks/useHasPermission';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { cn } from '@/new/lib/utils';

interface CreateSubsetButtonProps {
  matterId: string;
  hasProcessingSubset: boolean;
}

export function CreateSubsetButton({ matterId, hasProcessingSubset }: CreateSubsetButtonProps) {
  return (
    <PermissionGate permission={Permission.SubsetCreate} uiMode="disabled">
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={hasProcessingSubset ? 0 : undefined}>
            <Button variant="primary" asChild data-tour="create-subset-btn" disabled={hasProcessingSubset}>
              <Link
                to={`/matters/${matterId}/subsets/new`}
                onClick={() => trackCustomEvent(TrackingEventsV2.SubsetOpenCreateNew, { matterId })}
                className={cn(hasProcessingSubset && 'pointer-events-none opacity-50')}
              >
                <Icon className="lucide--group" />
                <span>Create a New Subset</span>
              </Link>
            </Button>
          </span>
        </TooltipTrigger>
        {hasProcessingSubset && (
          <TooltipContent>
            Please wait for existing Subsets to finish being created before creating a new Subset.
          </TooltipContent>
        )}
      </Tooltip>
    </PermissionGate>
  );
}
